import React from 'react';
import { Section, SectionHeader } from 'rebass';
import TweetTimeline from './TweetTimeline';

export default function LinksSection() {
  return (
    <Section>
      <SectionHeader heading="Art of Spoonerism" />
      <p>
        <a href="https://twitter.com/artofspoonerism">@artofspoonerism</a> generates fresh new spoonerisms from <a href="https://en.wikipedia.org/wiki/Special:Random">Wikipedia</a> every day on Twitter!
      </p>
      <TweetTimeline />
    </Section>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/LinksSection.js
 **/